import { Box, styled } from '@mui/material';

import { GRADIENTS } from '../../constants';

export const MarkRoot = styled(Box)({
  background: GRADIENTS.mark,
  padding: '0.02em 0.18em',
  boxDecorationBreak: 'clone',
  WebkitBoxDecorationBreak: 'clone',
});
